import { getStates, getCities, getCommunities } from "../../../services/LocationService";
import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Card, message, Tooltip } from "antd";
import Component from "../../../components";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MaintenanceAction from "../../../redux/actions/AuthAction/MaintenanceAction";
import AdditionalFeeAction from "../../../redux/actions/AuthAction/AdditionalFeeAction";
import DisclaimerAction from "../../../redux/actions/AuthAction/DisclaimerAction";
import Spinner from "../../../components/Spinner/Spiner";
import Checkbox from "antd/es/checkbox/Checkbox";
import DateTimePicker from "../../../components/dateTime/DateTime";
import TenantAction from "../../../redux/actions/AuthAction/TenantAction";
import moment from "moment";
import dayjs from "dayjs";
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CommonFunction from "../../../utils/CommonFunciton";
import Constants from "../../../utils/Constants";
import JwtAuthService from "../../../services/JwtAuthService";
import '../../../App.css';
const Tenant = () => {
  const dispatch = useDispatch();
  const {
    TextInput,
    SelectBox,
    CheckBox,
    UploadButton,
    TextArea,
    DynamicTable,
    Modal,
    Radio,
    DynamicForm,
  } = Component;
  const [dueDate, setDueDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [formCount, setFormCount] = useState(0);
  const [temp, setTemp] = useState({});
  const [formData, setFormData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [page, setPage] = useState("");
  const [isEmergencyContactModalVisible, setIsEmergencyContactModalVisible] =
    useState(false);
  const [isVehicleModalVisible, setIsVehicleModalVisible] = useState(false);
  const [isContactModalVisible, setIsContactModalVisible] = useState(false);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [reasonCodeMessage, setReasonCodeMessage] = useState(false);
  const [statusMessage, setStatusMessage] = useState(false);
  const [payaResponse, setPayaResponse] = useState(null);
  const [showContactTable, setShowContactTable] = useState(false);
  const [isPetModalVisible, setIsPetModalVisible] = useState(false);
  const [tenantData, setTenantData] = useState([]);
  const [tenantId, setTenantId] = useState(1);
  const [toEditId, setToEditId] = useState(0);
  const [toEditVehicleId, setToEditVehicleId] = useState(0);
  const [toEditPetId, setToEditPetId] = useState(0);
  const [contactPage, setContactPage] = useState("");
  const [vehiclePage, setVehiclePage] = useState("");
  const [petPage, setPetPage] = useState("");
  const [conatcToEditId, setContactToEditId] = useState(0);
  const [petId, setPetId] = useState(1);
  const [contactId, setContactId] = useState(1);
  const [vehicleId, setVehicleId] = useState(1);
  const [vehicleData, setVehicleData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [petData, setPetData] = useState([]);
  const [state, setState] = useState([]);
  const [form] = Form.useForm();
  const [tenantForm] = Form.useForm();
  const [vehicleForm] = Form.useForm();
  const [contactForm] = Form.useForm();
  const [petForm] = Form.useForm();
  const [maintenance, setMaintenance] = useState({});
  const [vehicle, setVehicle] = useState({});
  const [contact, setContact] = useState({});
  const [pet, setPet] = useState({});
  const [tenant, setTenant] = useState({});
  const [city, setCity] = useState([]);
  const [tenantCity, setTenantCity] = useState([]);
  const [mailingCity, setMailingCity] = useState([]);
  const [propertyCity, setPropertyCity] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [paymentForm] = Form.useForm();
  const [fee, setFee] = useState(null);
  const [isLoadingPaymentResponse, setIsLoadingPaymentResponse] = useState(false);
  const [registrationId, setRegistrationId] = useState(null);
  const [paymentToken, setPaymentToken] = useState(null);
  const [paymentFormUrl, setPaymentFormUrl] = useState(null);
  const [isPaymentFormUnavailable, setIsPaymentFormUnavailable] = useState(false);
  const [isNewRegistration, setIsNewRegistration] = useState(false);

  const [isAchPayment, setIsAchPayment] = useState(false);
  const [stateDisclaimer, setStateDisclaimer] = useState("");
  const [propertyDisclaimer, setPropertyDisclaimer] = useState("");
  const [stateDisclaimerId, setStateDisclaimerId] = useState(null);
  const [propertyDisclaimerId, setPropertyDisclaimerId] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState("");
  const [fileList, setFileList] = useState([]);
  const [formatted, setFormatted] = useState({});
  const [isEcModalVisible, setIsEcModalVisible] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [tenantState, setTenantState] = useState("");
  const [mailingState, setMailingState] = useState("");
  const [hasVehicle, setHasVehicle] = useState(false);
  const [hasPet, setHasPet] = useState(false);
  const tanantRes = useSelector(state => state);
  const getUniqueRecords = (data, keys) => {
    data.sort((a, b) => a.name.localeCompare(b.name));
    const seen = new Set();
    return data.filter((item) => {
      const keyss = keys.map((k) => item[k]?.trim()).join("|");
      const key = keys.map((k) => item[k]?.trim()).join("|");
      if (seen.has(key)) {
        return false;
      }

      if (key?.trim() !== "|") {
        seen.add(key);
        return true;
      }
      return false;
    });
  };

  // The API signs the Paya payment form, with the token it returned for this registration, so the Paya
  // keys never reach the browser (AAAW-935).
  useEffect(() => {
    setPaymentFormUrl(null);
    setIsPaymentFormUnavailable(false);
    if (!isPaymentModalVisible || !registrationId) return undefined;

    let isCurrent = true;
    JwtAuthService.postApi(
      { registrationId, paymentMethod: isAchPayment ? "ach" : "cc", paymentToken },
      "api/Tenant/NewRegistrationPaymentFormUrl"
    )
      .then((res) => {
        if (!isCurrent) return;
        setPaymentFormUrl(res?.url ?? null);
        setIsPaymentFormUnavailable(!res?.url);
      })
      .catch(() => {
        if (isCurrent) setIsPaymentFormUnavailable(true);
      });
    return () => {
      isCurrent = false;
    };
  }, [isPaymentModalVisible, isAchPayment, registrationId, paymentToken]);

  useEffect(() => {
    if (!paymentFormUrl) return undefined;
    // Only the Paya form opened above may report a payment.
    const allowed = new URL(paymentFormUrl).origin;
    const receiveMessage = (event) => {
      if (event.origin !== allowed) return;
      setIsLoadingPaymentResponse(true);
      setIsPaymentModalVisible(false);
      setPayaResponse(JSON.parse(event.data));
    };
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage, false);
  }, [paymentFormUrl]);
  const handleEdit = (tenantToEdit) => {
    setToEditId(tenantToEdit.id);
    let tempTenant = {};
    tempTenant["tenantId"] = tenantToEdit.id;
    tempTenant["tenantFirstName"] = tenantToEdit.FirstName;
    tempTenant["tenantLastName"] = tenantToEdit.LastName;
    tempTenant["tenantDesignation"] = tenantToEdit.Designation;
    tempTenant["tenantPhone"] = tenantToEdit.Phone;
    tempTenant["tenantEmail"] = tenantToEdit.Email;
    tempTenant["violation"] = tenantToEdit.Voilation;
    tempTenant["sendCopyToTenant"] = tenantToEdit.SendCopyToTenant;
    tempTenant["contactData"] = tenantToEdit.EmergencyContacts;
    setContactData(tenantToEdit.EmergencyContacts);
    setTemp(tempTenant);
    setTenant(tempTenant);
    tenantForm.setFieldsValue(tempTenant);
    showModal("Edit");
  };
  const handleEditContact = (contactToEdit) => {
    setContactToEditId(contactToEdit.id);
    let tempContact = {};
    tempContact["contactFirstName"] = contactToEdit.FirstName;
    tempContact["contactLastName"] = contactToEdit.LastName;
    tempContact["contactEmail"] = contactToEdit.Email;
    tempContact["contactPhone"] = contactToEdit.Phone;
    tempContact["contactRelationship"] = contactToEdit.Relationship;
    contactForm.setFieldsValue(tempContact);
    setContact(tempContact);
    showContactModal("Edit");
  };
  const handleEditVehicle = (vehicleToEdit) => {
    setToEditVehicleId(vehicleToEdit.id);
    let tempVehicle = {};
    tempVehicle["vehicleYear"] = vehicleToEdit.Year;
    tempVehicle["vehicleMake"] = vehicleToEdit.Make;
    tempVehicle["vehicleModel"] = vehicleToEdit.Model;
    tempVehicle["vehicleColor"] = vehicleToEdit.Color;
    tempVehicle["vehicleLicensePlate"] = vehicleToEdit.License;
    tempVehicle["vehicleState"] = vehicleToEdit.State;
    tempVehicle["vehicleSpot"] = vehicleToEdit.Spot;
    vehicleForm.setFieldsValue(tempVehicle);
    setVehicle(tempVehicle);
    showVehicleModal("Edit");
  };
  const handleEditPet = (petToEdit) => {
    setToEditPetId(petToEdit.id);
    let tempPet = {};
    tempPet["petName"] = petToEdit.Name;
    tempPet["petType"] = petToEdit.Type;
    tempPet["petBreed"] = petToEdit.Breed;
    tempPet["petDueDate"] = dayjs(dueDate, "MM/DD/YYYY");
    tempPet["petLicense"] = petToEdit.License;
    tempPet["petAge"] = petToEdit.Age;
    petForm.setFieldsValue(tempPet);
    setPet(tempPet);
    showPetModal("Edit");
  };

  const allDisRes = useSelector((state) => state.GetAllDisclaimer);
  const disObject = allDisRes?.GetAllDisclaimer;
  const allFeeRes = useSelector((state) => state?.GetAllAdditionalFee);
  const feeObject = allFeeRes.GetAllAdditionalFee;
  const additionalFeeResponse = useSelector((state) => state?.GetAdditionalFee);
  const mailingCities = useSelector((state) => state?.GetAllCitiesFromState.CountryStateCities);
  const [newStates, setNewStates] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const tenantRes = useSelector((state) => state?.CreateTenant);

  const showModal = (mode) => {
    setIsModalVisible(true);
    setPage(mode);
  };
  const showVehicleModal = (mode) => {
    setIsVehicleModalVisible(true);
    setVehiclePage(mode);
  };
  const showContactModal = (mode) => {
    setIsContactModalVisible(true);
    setContactPage(mode);
  };
  const showPetModal = (mode) => {
    setIsPetModalVisible(true);
    setPetPage(mode);
  };
  const openEmergencyContactModal = () => {
    setIsEmergencyContactModalVisible(true);
  };
  const handlePetDelete = (id) => {
    const updatedData = petData.filter((pet) => pet.id !== id);
    setPetData(updatedData);
    message.success("Pet deleted successfully!");
  };
  function handleTenantDelete(id) {
    const updatedData = tenantData.filter((tenant) => tenant.id !== id);
    setTenantData(updatedData);
    message.success("Tenant deleted successfully!");
  }
  const handleContactDelete = (id) => {
    const updatedData = contactData.filter((contact) => contact.id !== id);
    setContactData(updatedData);
    message.success("Contact deleted successfully!");
  };
  const handleVehicleDelete = (id) => {
    const updatedData = vehicleData.filter((vehicle) => vehicle.id !== id);
    setVehicleData(updatedData);
    message.success("Vehicle deleted successfully!");
  };
  const closeEmergencyContactModal = () => {
    setIsEmergencyContactModalVisible(false);
  };
  const handleCancel = () => {
    tenantForm.resetFields();
    setIsModalVisible(false);
  };
  const handleVehicleCancel = () => {
    vehicleForm.resetFields();
    setIsVehicleModalVisible(false);
  };
  const handleContactCancel = () => {
    contactForm.resetFields();
    setIsContactModalVisible(false);
  };
  const handlePetCancel = () => {
    petForm.resetFields();
    setIsPetModalVisible(false);
  };
  const handlePaymentCancel = () => {
    if (reasonCodeMessage) {
      Swal.fire({
        title: `${statusMessage}`,
        text: `Reason: ${reasonCodeMessage}`,
        icon: "error",
        confirmButtonColor: "#5A7890",
      });
    }
    else {
      if (isNewRegistration == true && payaResponse) {
        Swal.fire({
          title: isAchPayment ? 'ACH - Accepted' : 'CC - Approved',
          text: isAchPayment ? `${statusMessage}` : `Payment Done Successfully.`,
          icon: "success",
          confirmButtonColor: "#5A7890",
        });
      }
      else {
        Swal.fire({
          text: "Request Submitted Successfully.",
          icon: "success",
          confirmButtonColor: "#5A7890",
          customClass: {
            title: "text-danger",
            content: "text-danger",
          },
        });
      }

    }

    paymentForm.resetFields();
    setIsPaymentModalVisible(false);
    handleClearButton();
  };

  const handleShowConfirmation = () => {
    setIsConfirmVisible(true);
  };

  const handleConfirmCancel = () => {
    setIsConfirmVisible(false);
    dispatch(TenantAction.SetSkippedPaymentRequest({ id: registrationId, paymentToken }))
    handlePaymentCancel();
  };

  const handleCancelConfirmation = () => {
    setIsConfirmVisible(false);
  };
  useEffect(() => {
    if (payaResponse) {
      const statusMessage = CommonFunction.getStatusMessage(payaResponse?.status_id);
      const reasonCodeMessage = CommonFunction.getReasonCodeMessage(payaResponse?.reason_code_id);
      const typeMessage = CommonFunction.getTypeMessage(payaResponse?.type_id);
      setReasonCodeMessage(reasonCodeMessage);
      setStatusMessage(statusMessage);
      let request = {
        request: payaResponse,

      };
      dispatch(TenantAction.UpdatePaymentTenantRequest(request))
    }

  }, [payaResponse]);

  useEffect(() => {
    if (tenantRes?.PaymentTenant?.status) {
      handleClearButton();
      handlePaymentCancel();
    }
    else if (tenantRes?.PaymentTenant?.status === false) {
      Swal.fire({
        text: tenantRes?.PaymentTenant?.message,
        icon: "error",
        confirmButtonColor: "#5A7890",
        customClass: {
          title: "text-danger",
          content: "text-danger",
        },
      });
    }
    setIsLoadingPaymentResponse(false)
  }, [tenantRes?.PaymentTenant])
  const handleFormSubmit = (values) => {
    if (!isContactModalVisible) {
      const newTenant = {
        id: tenantId,
        FirstName: tenant.tenantFirstName,
        LastName: tenant.tenantLastName,
        Phone: tenant.tenantPhone,
        Email: tenant.tenantEmail,
        Voilation: tenant.violation == true ? true : false,
        SendCopyToTenant: tenant.sendCopyToTenant == true ? true : false,
        EmergencyContacts: contactData,
      };
      if (page === "Edit") {
        newTenant.id = toEditId;
        const updatedTenants = tenantData.map((t) =>
          t.id === newTenant.id ? newTenant : t
        );
        setTenantData(updatedTenants);
      } else {
        setTenantId(tenantId + 1);
        setTenantData([...tenantData, newTenant]);
      }
      setContactData([]);
      setTenant({});
      tenantForm.resetFields();
      setIsModalVisible(false);
      if (page === "Edit") {
        message.success("Tenant updated successfully!");
      }
      else {
        message.success("Tenant added successfully!");
      }
    }
  };
  const handleVehicleFormSubmit = (values) => {
    const newVehicle = {
      id: vehicleId,
      Year: vehicle.vehicleYear,
      Make: vehicle.vehicleMake,
      Model: vehicle.vehicleModel,
      Color: vehicle.vehicleColor,
      License: vehicle.vehicleLicensePlate,
      State: vehicle.vehicleState,
      Spot: vehicle.vehicleSpot,
    };
    if (vehiclePage === "Edit") {
      newVehicle.id = toEditVehicleId;
      const updatedVehicles = vehicleData.map((v) =>
        v.id === newVehicle.id ? newVehicle : v
      );
      setVehicleData(updatedVehicles);
    } else {
      setVehicleId(vehicleId + 1);
      setVehicleData([...vehicleData, newVehicle]);
    }

    vehicleForm.resetFields();
    setVehicle({});
    setIsVehicleModalVisible(false);
    if (vehiclePage === "Edit") {
      message.success("Vehicle updated successfully!");
    }
    else {
      message.success("Vehicle added successfully!");
    }
  };
  const handleContactFormSubmit = (values) => {
    const newContact = {
      id: contactId,
      FirstName: contact.contactFirstName,
      LastName: contact.contactLastName,
      Email: contact.contactEmail,
      Phone: contact.contactPhone,
      Relationship: contact.contactRelationship,
    };

    if (contactPage === "Edit") {
      newContact.id = conatcToEditId;
      const updatedContacts = contactData.map((c) =>
        c.id === newContact.id ? newContact : c
      );
      setContactData(updatedContacts);
    } else {
      setContactId(contactId + 1);
      setContactData([...contactData, newContact]);
    }

    contactForm.resetFields();
    setContact({});
    setIsContactModalVisible(false);
    if (contactPage === "Edit") {
      message.success("Contact updated successfully!");
    }
    else {
      message.success("Contact added successfully!");
    }
  };
  const handlePetFormSubmit = (values) => {
    const newPet = {
      id: petId,
      Name: pet.petName,
      Type: pet.petType,
      Breed: pet.petBreed,
      RabiesDueDate: dueDate,
      License: pet.petLicense,
      Age: pet.petAge,
    };
    if (petPage === "Edit") {
      newPet.id = toEditPetId;
      const updatedPets = petData.map((p) => (p.id === newPet.id ? newPet : p));
      setPetData(updatedPets);
    } else {
      setPetId(petId + 1);
      setPetData([...petData, newPet]);
    }

    petForm.resetFields();
    setPet({});
    setIsPetModalVisible(false);
    if (petPage === "Edit") {
      message.success("Pet updated successfully!");
    }
    else {
      message.success("Pet added successfully!");
    }
  };
  const handleDateChange = (date, dateString) => {
    setDueDate(dateString);
  };
  const handleStartDateChange = (date, dateString) => {
    setStartDate(dateString);
  };
  const handleEndDateChange = (date, dateString) => {
    setEndDate(dateString);
  };
  const options = [
    {
      value: true,
      name: "New",
    },
    {
      value: false,
      name: "Renewal",
    },
  ];
  const paymentOptions = [
    { name: "Pay with Credit Card", value: "CC" },
    { name: "Pay with eCheck/ACH", value: "ACH" },
  ];
  const handleRadioChange = (e) => {
    setIsAchPayment(e.target.value === "ACH");
  };
  const hasVehiclesOptions = [
    {
      value: true,
      name: "Yes",
    },
    {
      value: false,
      name: "No",
    },
  ];
  const hasPetOptions = [
    {
      value: true,
      name: "Yes",
    },
    {
      value: false,
      name: "No",
    },
  ];
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleChange = ({ fileList: newFileList }) => {
    let fileNames = [];
    let i = 0;
    newFileList.forEach((file) => {
      if (i == 0) {
        fileNames = [...fileNames, file.name];
        i = i + 1;
      } else {
        if (fileNames.includes(file.name)) {
          Swal.fire({
            title: "Warning",
            text: "File name already exists.(" + file.name + ")",
            icon: "warning",
            confirmButtonColor: "#44637e",
          });
          newFileList.splice(newFileList.indexOf(file), 1);
        } else {
          fileNames = [...fileNames, file.name];
        }
      }
      setFileList(fileNames);
    });
    const maxSize = 5 * 1024 * 1024 * 1024;
    let totalSize = 0;
    let filesChecked = [];
    newFileList.forEach((file) => {
      totalSize = totalSize + file?.originFileObj?.size;
      if (totalSize > maxSize) {
        Swal.fire({
          title: "Warning",
          text: "Cannot upload files of size more than 5 GB.",
          icon: "warning",
          confirmButtonColor: "#44637e",
        });
      } else {
        filesChecked.push(file);
      }
    });
    setFileList(filesChecked);
  };

  const onFinish = (values) => {
    if (
      !isContactModalVisible &&
      !isVehicleModalVisible &&
      !isPetModalVisible &&
      !isModalVisible
    ) {
      if (tenantData.length == 0) {
        Swal.fire({
          text: "Please provide at least one tenant's information.",
          icon: "warning",
          confirmButtonColor: "#5A7890",
          customClass: {
            title: "text-danger",
            content: "text-danger",
          },
        });
        return;
      }


      try {
        const formData = new FormData();
        formData.append("state", form.getFieldValue("state"));
        formData.append("city", form.getFieldValue("city"));
        formData.append("property", form.getFieldValue("communities"));
        formData.append(`leaseInfo.newOrRenew`, form.getFieldValue("newOrRenew") ? "New" : "Renewal");
        formData.append(`leaseInfo.startDay`, startDate);
        formData.append(`leaseInfo.endDay`, endDate);
        if (fee) {
          formData.append(`amount`, fee);
        }
        if (form.getFieldValue("sendCopyToEmail")) {
          formData.append(`SendCopyToEmail`, form.getFieldValue("sendCopyToEmail"));
        }
        formData.append(`SubmitterFirstName`, form.getFieldValue("submitterFirstName"));
        formData.append(`SubmitterLastName`, form.getFieldValue("submitterLastName"));
        formData.append(`SubmitterEmail`, form.getFieldValue("submitterEmail"));
        if (form.getFieldValue("submitterTelephone")) {
          formData.append(`SubmitterTelephone`, form.getFieldValue("submitterTelephone"));
        }
        formData.append(`PropertyFullAddress`, form.getFieldValue("propertyFullAddress"));
        formData.append(`PropertyZip`, form.getFieldValue("propertyZip"));
        if (form.getFieldValue("mailingAddress")) {
          formData.append(`MailingAddress`, form.getFieldValue("mailingAddress"));

        }
        if (form.getFieldValue("mailingCity")) {
          formData.append(`MailingCity`, form.getFieldValue("mailingCity"));
        }
        formData.append(`PropertyCity`, form.getFieldValue("propertyCity"));
        formData.append(`PropertyState`, form.getFieldValue("propertyState"));
        if (form.getFieldValue("mailingState")) {
          formData.append(`MailingState`, form.getFieldValue("mailingState"));

        }
        if (form.getFieldValue("mailingZip")) {
          formData.append(`MailingZip`, form.getFieldValue("mailingZip"));
        }
        if (propertyDisclaimer) {
          formData.append(`propertyDisclaimer`, propertyDisclaimer);
          formData.append(`propertyDisclaimerId`, propertyDisclaimerId);
        }
        if (stateDisclaimer) {
          formData.append(`stateDisclaimer`, stateDisclaimer);
          formData.append(`stateDisclaimerId`, stateDisclaimerId);
        }

        fileList.forEach((file, index) => { formData.append(`supportingDocuments`, file.originFileObj, file.name); });
        tenantData.forEach((obj, index) => {
          formData.append(`tenants[${index}].firstName`, obj.FirstName);
          formData.append(`tenants[${index}].lastName`, obj.LastName);
          formData.append(`tenants[${index}].phone`, obj.Phone);
          formData.append(`tenants[${index}].email`, obj.Email);
          formData.append(`tenants[${index}].voilation`, obj.Voilation ? "true" : "false");
          formData.append(`tenants[${index}].sendCopyToTenant`, obj.SendCopyToTenant ? "true" : "false");
          obj.EmergencyContacts.forEach((contact, i) => {
            formData.append(`tenants[${index}].emergencyContacts[${i}].firstName`, contact.FirstName);
            formData.append(`tenants[${index}].emergencyContacts[${i}].lastName`, contact.LastName);
            if (contact.Email) {
              formData.append(`tenants[${index}].emergencyContacts[${i}].email`, contact.Email);
            }
            formData.append(`tenants[${index}].emergencyContacts[${i}].phone`, contact.Phone);
            if (contact.Relationship) {
              formData.append(`tenants[${index}].emergencyContacts[${i}].relationship`, contact.Relationship);
            }
          });
        });
        vehicleData.forEach((obj, index) => {
          formData.append(`vehicles[${index}].make`, obj.Make);
          formData.append(`vehicles[${index}].model`, obj.Model);
          formData.append(`vehicles[${index}].year`, obj.Year);
          formData.append(`vehicles[${index}].color`, obj.Color);
          formData.append(`vehicles[${index}].license`, obj.License);
          formData.append(`vehicles[${index}].state`, obj.State);
          if (obj.Spot) {
            formData.append(`vehicles[${index}].spot`, obj.Spot);
          }
        });
        petData.forEach((obj, index) => {
          formData.append(`pets[${index}].name`, obj.Name);
          if (obj.Type) {
            formData.append(`pets[${index}].type`, obj.Type);
          }
          formData.append(`pets[${index}].breed`, obj.Breed);

          if (obj.RabiesDueDate) {
            formData.append(`pets[${index}].rabiesDueDate`, obj.RabiesDueDate);
          }
          if (obj.License) {
            formData.append(`pets[${index}].license`, obj.License);
          }
          formData.append(`pets[${index}].age`, obj.Age);
        });
        let req = {
          request: formData,
          handle: HandleRes,
        };

        if (formData) {
          dispatch(TenantAction.CreateTenantRequest(req));
        }
      } catch (error) {
        Swal.fire({
          text: "Submission unsuccessful. Please try again or contact us.",
          icon: "error",
          confirmButtonColor: "#5A7890",
          customClass: {
            title: "text-danger",
            content: "text-danger",
          },
        });
      }
    }
  };
  useEffect(() => {
    if (tanantRes?.CreateTenant?.CreateTenant?.status) {
      setRegistrationId(tanantRes?.CreateTenant?.CreateTenant?.data);
      setPaymentToken(tanantRes?.CreateTenant?.CreateTenant?.paymentToken ?? null);
      if (isNewRegistration && fee) {
        setIsPaymentModalVisible(true);
      }
      else {
        handleClearButton();
        Swal.fire({
          text: "Request Submitted Successfully.",
          icon: "success",
          confirmButtonColor: "#5A7890",
          customClass: {
            title: "text-danger",
            content: "text-danger",
          },
        });
      }
    }
    else if (tanantRes?.CreateTenant?.CreateTenant?.status == false) {
      Swal.fire({
        text: "error",
        icon: "error",
        confirmButtonColor: "#5A7890",
        customClass: {
          title: "text-danger",
          content: "text-danger",
        },
      });
    }
  }, [tanantRes?.CreateTenant?.CreateTenant])
  const HandleRes = () => {
    handleClearButton();
  };
  const onFinishFailed = (errorInfo) => {
    form.validateFields()
      .then((values) => {


      })
      .catch((errorInfo) => {

        message.error({ content: "Please provide all required data!", style: { textAlign: 'right' } })

      });
  };

  const HandleOnChange = async (e) => {
    const { id, value } = e?.target;
    const updatedMaintenance = { ...maintenance, [id]: value };
    setMaintenance(updatedMaintenance);
    form.setFieldsValue(updatedMaintenance);

    if (id === "propertyState") {
      setLoadingLocations(true);
      try {
        const res = await getCities(value);
        const newCities = (res?.data || []).map((c) => ({ name: c.cityName, value: c.cityId }));
        setPropertyCity(getUniqueRecords(newCities, ["name", "value"]));
      } catch {
        Swal.fire({ text: "Unable to load cities. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
      } finally {
        setLoadingLocations(false);
      }
    }

    if (id === "state") {
      setStateDisclaimer("");
      setPropertyDisclaimer("");
      form.setFieldsValue({ propertyState: value });
      form.resetFields(["city", "communities"]);
      setLoadingLocations(true);
      try {
        const res = await getCities(value);
        const newCities = (res?.data || []).map((c) => ({ name: c.cityName, value: c.cityId }));
        const unique = getUniqueRecords(newCities, ["name", "value"]);
        const selectorCities = unique.filter(
          (c) => !Constants.EXCLUDED_CITIES.includes(c.name?.trim().toLowerCase())
        );
        setCity(selectorCities);
        setPropertyCity(unique);
      } catch {
        Swal.fire({ text: "Unable to load cities. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
      } finally {
        setLoadingLocations(false);
      }
    }

    if (id === "city") {
      form.setFieldsValue({ propertyCity: value });
      form.resetFields(["communities"]);
      const selectedState = form.getFieldValue("state");
      setLoadingLocations(true);
      try {
        const res = await getCommunities(selectedState, value);
        const newCommunities = (res?.data || [])
          .map((c) => ({ name: c.communityName, value: c.communityId }));
        setCommunities(getUniqueRecords(newCommunities, ["name", "value"]));
      } catch {
        Swal.fire({ text: "Unable to load communities. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
      } finally {
        setLoadingLocations(false);
      }
    }

    if (id === "communities") {
      setFee("");
      setPropertyDisclaimer("");
      dispatch(DisclaimerAction.GetAllDisclaimerRequest({ propertyId: value }));
    }
  };

  const HandleMailingCityChange = async (e) => {
    const { id, value } = e?.target;
    dispatch(TenantAction.GetAllCitiesFromStateRequest(value));
  };

  const HandleTenantOnChange = async (e) => {
    const { name, id, value } = e?.target;
    let updatedTenant;
    if (name == "violation" || name == "age" || name == "sendCopyToTenant") {
      updatedTenant = { ...tenant, [name]: e.target.checked };
    } else {
      updatedTenant = { ...tenant, [id]: value };
    }

    setTenant(updatedTenant);
    tenantForm.setFieldsValue(updatedTenant);
  };
  const HandleVehicleOnChange = async (e) => {
    const { id, value } = e?.target;
    const updatedVehicle = { ...vehicle, [id]: value };
    setVehicle(updatedVehicle);
    vehicleForm.setFieldsValue(updatedVehicle);
  };
  const HandleContactOnChange = async (e) => {
    const { id, value } = e?.target;
    const updatedContact = { ...contact, [id]: value };
    setContact(updatedContact);
    contactForm.setFieldsValue(updatedContact);
  };
  const HandlePetOnChange = async (e) => {
    const { id, value } = e?.target;
    const updatedPet = { ...pet, [id]: value };
    setPet(updatedPet);
    petForm.setFieldsValue(updatedPet);
  };

  const handleCardNumberChange = (e) => {
    const { value } = e.target;

    const cleaned = value.replace(/\D+/g, "");

    const limited = cleaned.slice(0, 16);

    const formattedCard = limited.match(/.{1,4}/g)?.join(" ") || "";

    const formatted = { cardNumber: formattedCard };

    setFormatted(formatted);
    paymentForm.setFieldsValue(formatted);
  };


  const validateExpiryDate = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    const formatRegex = /^(0[1-9]|1[0-2])\/\d{2}$/;
    if (!formatRegex.test(value)) {
      return Promise.reject(
        new Error("Expiry Date must be in the format MM/YY")
      );
    }

    const month = parseInt(value.slice(0, 2), 10);
    const year = parseInt(value.slice(3, 5), 10);

    const now = moment();
    const currentYear = now.year();
    const currentMonth = now.month() + 1;

    const fullYear = year >= currentYear % 100 ? 2000 + year : 1900 + year;

    if (month < 1 || month > 12) {
      return Promise.reject(
        new Error("Expiry Date month must be between 01 and 12")
      );
    }

    const expiryDate = moment()
      .set({ year: fullYear, month: month - 1, date: 1 })
      .endOf("month");

    if (expiryDate.isBefore(now, "month")) {
      return Promise.reject(new Error("Expiry Date must be in the future"));
    }

    return Promise.resolve();
  };
  const validateCardNumber = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    const cleanedNumber = value.replace(/\s+/g, "");

    if (!/^\d{16}$/.test(cleanedNumber)) {
      return Promise.reject(
        new Error("Credit Card Number must be exactly 16 digits")
      );
    }

    return Promise.resolve();
  };
  const validatePhoneNumber = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/;

    if (!phoneRegex.test(value)) {
      return Promise.reject(
        new Error("Phone Number must be in the format (xxx) xxx-xxxx")
      );
    }

    return Promise.resolve();
  };

  const handleTelePhoneChange = (e) => {
    const { value } = e.target;
    const formattedPhone = CommonFunction.formatPhoneNumber(value)
    form.setFieldsValue({ submitterTelephone: formattedPhone });
  };

  const handlePhoneChange = (e) => {

    const { value } = e.target;

    const cleaned = value.replace(/\D+/g, "");

    const limited = cleaned.slice(0, 10);

    const formattedPhone = limited
      .replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3")
      .replace(/^(\d{3})(\d{3})$/, "($1) $2-")
      .replace(/^(\d{3})$/, "($1)");

    tenant["tenantPhone"] = formattedPhone;
    tenantForm.setFieldsValue(tenant);
  };

  const handleContactPhoneChange = (e) => {

    const { value } = e.target;

    const cleaned = value.replace(/\D+/g, "");

    const limited = cleaned.slice(0, 10);

    const formattedPhone = limited
      .replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3")
      .replace(/^(\d{3})(\d{3})$/, "($1) $2-")
      .replace(/^(\d{3})$/, "($1)");

    contact["contactPhone"] = formattedPhone;
    contactForm.setFieldsValue(contact);
  };

  const validateCVV = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    const cleanedNumber = value.replace(/\s+/g, "");

    if (!/^\d{4}$/.test(cleanedNumber) && !/^\d{3}$/.test(cleanedNumber)) {
      return Promise.reject(
        new Error("CVV can be either 3 or 4 digits long.")
      );
    }

    return Promise.resolve();
  };

  const validationRules = {
    relationship: [
      { pattern: /^[a-zA-Z\s]+$/, message: "Relation must contain only letters and spaces" },
    ],
    firstName: [
      { required: true, message: "First Name is required" },
      { pattern: /^[a-zA-Z\s]+$/, message: "First Name must contain only letters and spaces" },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("First Name cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    lastName: [
      { required: true, message: "Last Name is required" },
      { pattern: /^[a-zA-Z\s]+$/, message: "Last Name must contain only letters and spaces" },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Last Name cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    address: [
      { required: true, message: "Address is required" },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Address cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    state: [{ required: true, message: "State is required" }],
    city: [{ required: true, message: "City is required" }],
    property: [{ required: true, message: "Association is required" }],
    zip: [
      { required: true, message: "Zip code is required" },
      {
        pattern: /^[0-9]{5}(?:-[0-9]{4})?$/,
        message: "Valid Zip code formats are: 12345 and 12345-6789",
      },
      {
        validator: (rule, value) => {
          if (value && value.replace(/[^0-9]/g, "").length > 10) {
            return Promise.reject("Zip code cannot be longer than 10 digits");
          }
          return Promise.resolve();
        },
      },
    ],
    notRequiredZip: [
      {
        pattern: /^[0-9]{5}(?:-[0-9]{4})?$/,
        message: "Valid Zip code formats are: 12345 and 12345-6789",
      },
      {
        validator: (rule, value) => {
          if (value && value.replace(/[^0-9]/g, "").length > 10) {
            return Promise.reject("Zip code cannot be longer than 10 digits");
          }
          return Promise.resolve();
        },
      },
    ],
    phone: [
      { required: true, message: "Phone number is required" },
      { validator: validatePhoneNumber },
    ],
    notRequiredPhone: [
      { validator: validatePhoneNumber },
    ],
    email: [
      { required: true, message: "Email is required" },
      { type: "email", message: "Invalid email format" },
    ],
    notRequiredEmail: [
      { type: "email", message: "Invalid email format" },
    ],
    date: [
      {
        required: true,
        message: "Date is required",
      },
    ],
    year: [
      {
        required: true,
        m3000essage: "Year is required",
      },
      {
        pattern: /^[0-9]{4}$/,
        message: "Year must be a 4-digit number",
      },
      {
        validator: (_, value) => {
          const currentYear = new Date().getFullYear();
          if (!value || (value >= 1900 && value <= currentYear)) {
            return Promise.resolve();
          }
          return Promise.reject(
            new Error(`Year must be between 1900 and ${currentYear}`)
          );
        },
      },
    ],
    make: [
      {
        required: true,
        message: "Make is required",
      },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Make cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    model: [
      {
        required: true,
        message: "Model is required",
      },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Model cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    color: [
      {
        required: true,
        message: "Color is required",
      },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Color cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
      {
        pattern: /^[a-zA-Z\s]+$/,
        message: "Color must contain only letters and spaces",
      },
    ],
    license: [
      {
        required: true,
        message: "License is required",
      },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("License cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    name: [
      { required: true, message: "Name is required" },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Name cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
      {
        pattern: /^[a-zA-Z\s]+$/,
        message: "Name must contain only letters and spaces",
      },
    ],
    breed: [
      { required: true, message: "Breed is required" },
      {
        validator: (rule, value) => {
          if (value && !value.trim()) {
            return Promise.reject("Breed cannot contain only spaces");
          }
          return Promise.resolve();
        },
      },
    ],
    age: [
      {
        required: true,
        message: "Age is required",
      },
      { pattern: /^\d*$/, message: "Age must be in digit(s)." },
    ],
    routingNumber: [
      {
        required: true,
        message: "Routing Number is required",
      },
      { pattern: /^\d*$/, message: "Routing Number must be in digit(s)." },
    ],
    newOrRenew: [
      {
        required: true,
        message: "Type of Lease is required.",
      },
    ],
    cardNumber: [
      {
        required: true,
        message: "Card Number is required",
      },
      { validator: validateCardNumber },
    ],
    accountNumber: [
      {
        required: true,
        message: "Account Number is required",
      },
      { pattern: /^\d*$/, message: "Account Number must be in digit(s)." },
    ],
    accountHolderName: [
      {
        required: true,
        message: "Account Holder Name is required",
      },
    ],
    cvv: [
      {
        required: true,
        message: "CVV is required",
      },
      { validator: validateCVV },
    ],
    cardExpiry: [
      {
        required: true,
        message: "Expiry Date is required",
      },
      { validator: validateExpiryDate },
    ],
    cardHolderName: [
      {
        required: true,
        message: "Card Holder Name is required",
      },
      {
        pattern: /^[a-zA-Z\s]+$/,
        message: "Card Holder Name must contain only letters and spaces",
      },
    ],
    endDate: [
      { required: true, message: 'Please select an end date' },
      { type: 'object', message: 'End date must be a valid date' },
      {
        validator: async (_, value) => {
          const startDate = form.getFieldValue('startDay');

          if (!startDate || !value) {
            return;
          }

          if (value.isBefore(startDate) || value.isSame(startDate)) {
            return Promise.reject('End date must be greater than start date');
          }

          return Promise.resolve();
        }
      }
    ],
  };

  const handleZipChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "");

    if (value.length > 5) {
      value = value.slice(0, 5) + "-" + value.slice(5, 9);
    }

    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    e.target.value = value;
    HandleOnChange(e);
  };

  const getMailingCities = (cities) => {
    if (!Array.isArray(cities)) return [];

    return cities.map(city => ({
      name: city.name,
      value: city.name,
    }));
  };

  function handleClearButton() {
    form.resetFields();
    petForm.resetFields();
    tenantForm.resetFields();
    contactForm.resetFields();
    vehicleForm.resetFields();
    setCity([]);
    setCommunities([]);
    setStateDisclaimer("");
    setPropertyDisclaimer("");
    setTenantData([]);
    setContactData([]);
    setPetData([]);
    setVehicleData([]);
    setFileList([]);
    setPropertyCity({})
    setDueDate(null);
    setStartDate(null);
    setEndDate(null);
    setMaintenance({})
  }

  useEffect(() => {
    (async () => {
      setLoadingLocations(true);
      try {
        const res = await getStates();
        setNewStates((res?.data || []).map((s) => ({ name: s.stateName, value: s.stateId })));
      } catch {
        Swal.fire({ text: "Unable to load states. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
      } finally {
        setLoadingLocations(false);
      }
    })();
  }, []);

  // useEffect(() => {
  //   dispatch(AdditionalFeeAction.GetAllAdditionalFeeRequest());
  // }, []);

  useEffect(() => {
    if (disObject) {
      if (disObject.status) {
        setFee(disObject?.data?.propertyFee);
        setPropertyDisclaimer(disObject?.data?.propertyDisclaimer);
        setPropertyDisclaimerId(disObject?.data?.propertyDisclaimerId);
        setStateDisclaimer(disObject?.data?.stateDisclaimer);
        setStateDisclaimerId(disObject?.data?.stateDisclaimerId);
      }
    }
  }, [disObject]);
  const columns = [
    { title: "First Name", dataIndex: "FirstName", key: "FirstName" },
    { title: "Last Name", dataIndex: "LastName", key: "LastName" },
    { title: "Phone", dataIndex: "Phone", key: "Phone" },
    { title: "Email", dataIndex: "Email", key: "Email" },
    {
      title: "Violation",
      dataIndex: "Voilation",
      key: "Voilation",
      render: (text) => (text ? "Yes" : "No"),
    },
    {
      title: "Email To Tenant",
      dataIndex: "SendCopyToTenant",
      key: "SendCopyToTenant",
      render: (text) => (text ? "Yes" : "No"),
    },
    {
      title: "Emergency Contacts",
      dataIndex: "emergencyContacts",
      key: "emergencyContacts",
      render: (emergencyContacts, record) => (
        <Button
          style={{
            borderRadius: 19,
            border: "1px solid #5A7890",
            color: "#fff",
            backgroundColor: "#5A7890",
            height: "2rem",
            width: "7rem",
          }}
          onClick={() => handleViewContacts(record)}
        >
          View Contacts
        </Button>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <div className="d-flex">
            <Tooltip title="Edit">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#5b5b5b",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleEdit(record)}
                icon={<EditOutlined />}
              >
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#d11a2a",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleTenantDelete(record.id)}
                icon={<DeleteOutlined />}
              >
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  const vehicleColumns = [
    { title: "Year", dataIndex: "Year", key: "Year" },
    { title: "Make", dataIndex: "Make", key: "Make" },
    { title: "Model", dataIndex: "Model", key: "Model" },
    { title: "Color", dataIndex: "Color", key: "Color" },
    {
      title: "License Plate",
      dataIndex: "License",
      key: "License",
    },
    { title: "State", dataIndex: "State", key: "State" },
    { title: "Spot", dataIndex: "Spot", key: "Spot" },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <div className="d-flex">
            <Tooltip title="Edit">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#5b5b5b",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleEditVehicle(record)}
                icon={<EditOutlined />}
              >
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#d11a2a",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleVehicleDelete(record.id)}
                icon={<DeleteOutlined />}
              >
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  const petColumns = [
    { title: "Name", dataIndex: "Name", key: "Name" },
    { title: "Type", dataIndex: "Type", key: "Type" },
    { title: "Breed", dataIndex: "Breed", key: "Breed" },
    {
      title: "Rabies Due Date",
      dataIndex: "RabiesDueDate",
      key: "RabiesDueDate",
    },
    { title: "License", dataIndex: "License", key: "License" },
    { title: "Age", dataIndex: "Age", key: "Age" },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <div className="d-flex">
            <Tooltip title="Edit">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#5b5b5b",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleEditPet(record)}
                icon={<EditOutlined />}
              >
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#d11a2a",
                  backgroundColor: "#fff",
                }}
                onClick={() => handlePetDelete(record.id)}
                icon={<DeleteOutlined />}
              >
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  const contactColumns = [
    {
      title: "First Name",
      dataIndex: "FirstName",
      key: "FirstName",
    },
    {
      title: "Last Name",
      dataIndex: "LastName",
      key: "LastName",
    },
    { title: "Email", dataIndex: "Email", key: "Email" },
    { title: "Phone", dataIndex: "Phone", key: "Phone" },
    { title: "Relationship", dataIndex: "Relationship", key: "Relationship" },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <div className="d-flex">
            <Tooltip title="Edit">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#5b5b5b",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleEditContact(record)}
                icon={<EditOutlined />}
              >
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={{
                  boxShadow: 'none',
                  border: 'none',
                  borderRadius: 19,
                  color: "#d11a2a",
                  backgroundColor: "#fff",
                }}
                onClick={() => handleContactDelete(record.id)}
                icon={<DeleteOutlined />}
              >
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  const handleViewContacts = (tenant) => {
    setSelectedTenant(tenant);
    setIsEcModalVisible(true);
  };

  const handleModalOk = () => {
    setIsEcModalVisible(false);
    setSelectedTenant(null);
  };

  const handleModalCancel = () => {
    setIsEcModalVisible(false);
    setSelectedTenant(null);
  };

  const onSearch = (value) => {
    console.log(value);
  };

  const filterOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());
  const PaymentOpiton = (pageName) => (
    <>
      {(isLoadingPaymentResponse) && <Spinner />}
      <Form form={paymentForm}>
        <Radio
          label=""
          name="paymentMethod"
          options={paymentOptions}
          value={isAchPayment ? "ACH" : "CC"}
          onChange={handleRadioChange}
        />
        {isAchPayment && <>
          <p>By authorizing this transaction, customer agrees that merchant may convert this transaction into an Electronic Funds Transfer (EFT) transaction or paper draft, and to debit this account for the amount of the transaction. Additionally, in the event this draft or EFT is returned unpaid, a service fee, as allowable by law, will be charged to this account via EFT or draft. In the event you choose to revoke this authorization, please do so by contacting the merchant directly. Please note that processing times may not allow for revocation of this authorization.</p>
        </>}
        {paymentFormUrl && (
          <div className={`${!isAchPayment ? "first-frame" : "iframe"}`}>
            <iframe src={paymentFormUrl} title="Example iframe"></iframe>
          </div>
        )}
        {isPaymentFormUnavailable && (
          <p>Online payment is not available right now. Please try again later.</p>
        )}
      </Form>
    </>

  )
  return (
    <>
      {(loadingLocations ||
        tenantRes?.loading ||
        allFeeRes?.loading ||
        allDisRes?.loading || isLoadingPaymentResponse) && <Spinner />}
      <Row justify={"center"}>
        <div className="inner-page-wrapper">
          <Col sm={24} className="text-center">
            <div className="text-center">
              <h1 className="heading-maintenance" style={{ color: "#5A7890" }}>
                Tenant Registration
              </h1>
            </div>
          </Col>
          <Col sm={24} className="a">
            <div className="mt-4">
              <p className="disclaimer-notice">
                Please note, a tenant registration form is not considered an address change request, and mailing addresses will not be updated from the form.
                To update your mailing address, simply visit All Access app or web (<a href="https://allaccess.associatedasset.com">allaccess.associatedasset.com</a>) or your community’s website.
              </p>
              <p
                className="description-maintenance"
                style={{ fontSize: "16px", marginBottom: "5px", color: '#5b5b5b' }}
              >
                To see tenant registration rules in your location and register
                electronically, select your state below.
              </p>
            </div>
          </Col>
          <Col sm={24}>
            <Form
              style={{ marginBottom: "2rem" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              initialValues={{}}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
              className="custom-fields-form"
            >
              <SelectBox
                label="State"
                name="state"
                options={getUniqueRecords(newStates, ["name", "value"])}
                className="custom-scrollbar"
                placeholder="State"
                onChange={(e) => HandleOnChange(e)}
                size="large"
                rules={validationRules.state}
                showSearch={true}
                onSearch={onSearch}
                filterOption={filterOption}
              />

              {form.getFieldValue("state") && (
                <>
                  <SelectBox
                    label="City"
                    name="city"
                    options={getUniqueRecords(city, ["name", "value"])}
                    className="custom-scrollbar"
                    placeholder="City"
                    onChange={(e) => HandleOnChange(e)}
                    size="large"
                    rules={validationRules.city}
                    showSearch={true}
                    onSearch={onSearch}
                    filterOption={filterOption}
                  />
                </>
              )}

              {form.getFieldValue("city") && (
                <SelectBox
                  label="Association"
                  name="communities"
                  options={getUniqueRecords(communities, ["name", "value"])}
                  className="custom-scrollbar"
                  placeholder="Communities"
                  onChange={(e) => HandleOnChange(e)}
                  size="large"
                  rules={validationRules.property}
                  showSearch={true}
                  onSearch={onSearch}
                  filterOption={filterOption}
                />
              )}
              {form.getFieldValue("communities") && (
                <>
                  {stateDisclaimer && (
                    <div
                      style={{
                        marginTop: "3rem",
                        fontSize: "18px",
                        marginBottom: "2.5rem",
                        border: "1px solid #5A7890",
                        borderRadius: "8px",
                        paddingLeft: "20px",
                        paddingTop: "0.9rem",
                        paddingRight: "20px",
                        paddingBottom: "1rem",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "20px",
                          color: "#5A7890",
                          textAlign: "center",
                        }}
                      >
                        <b>State Disclaimers</b>
                      </p>
                      <div
                        style={{ fontSize: "16px", color: '#5b5b5b' }}
                        dangerouslySetInnerHTML={{ __html: stateDisclaimer }}
                      />
                    </div>
                  )}
                  {propertyDisclaimer && (
                    <div
                      style={{
                        fontSize: "18px",
                        marginBottom: "3rem",
                        border: "1px solid #5A7890",
                        paddingLeft: "20px",
                        paddingTop: "0.9rem",
                        paddingRight: "20px",
                        paddingBottom: "1rem",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "20px",
                          color: "#5A7890",
                          textAlign: "center",
                        }}
                      >
                        <b>Property Disclaimers</b>
                      </p>
                      <div
                        style={{ fontSize: "16px" }}
                        dangerouslySetInnerHTML={{ __html: propertyDisclaimer }}
                      />
                    </div>
                  )}
                  <p
                    style={{
                      color: "#5A7890",
                      fontSize: "22px",
                      marginBottom: "5px",
                      marginTop: "3rem",
                      fontWeight: "bold",
                    }}
                  >
                    Property Information
                  </p>
                  <Row gutter={16}>
                    <Col span={12} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.firstName}
                        name="submitterFirstName"
                        size="large"
                        label="First Name"
                        placeholder="Enter First Name"
                        onChange={(e) => HandleOnChange(e)}
                      />
                    </Col>
                    <Col span={12} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.lastName}
                        name="submitterLastName"
                        size="large"
                        label="Last Name"
                        placeholder="Enter Last Name"
                        onChange={(e) => HandleOnChange(e)}
                      />
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.email}
                        name="submitterEmail"
                        size="large"
                        label="Email"
                        placeholder="Enter Email"
                        onChange={(e) => HandleOnChange(e)}
                      />
                    </Col>
                    <Col span={12} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.notRequiredPhone}
                        name="submitterTelephone"
                        size="large"
                        label="Telephone Number"
                        placeholder="Enter Telephone Number"
                        onChange={(e) => handleTelePhoneChange(e)}
                      />
                    </Col>
                  </Row>
                  <p
                    style={{
                      color: "#5A7890",
                      fontSize: "16px",
                      marginBottom: "5px",
                      marginTop: "1rem",
                      fontWeight: "bold",
                    }}
                  >
                    Property Address
                  </p>
                  <Row gutter={16}>
                    <Col span={24} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.address}
                        name="propertyFullAddress"
                        size="large"
                        label="Address"
                        placeholder="Enter Property Address"
                        onChange={(e) => HandleOnChange(e)}
                      />
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={8} className="custom-input-box-wrap">
                      <SelectBox
                        label="State"
                        name="propertyState"
                        options={getUniqueRecords(newStates, [
                          "name",
                          "value",
                        ])}
                        className="custom-scrollbar"
                        placeholder="Select State"
                        onChange={(e) => HandleOnChange(e)}
                        size="large"
                        rules={validationRules.state}
                        showSearch={true}
                        onSearch={onSearch}
                        filterOption={filterOption}
                      />
                    </Col>
                    <Col span={8} className="custom-input-box-wrap">
                      <SelectBox
                        label="City"
                        name="propertyCity"
                        options={getUniqueRecords(propertyCity, [
                          "name",
                          "value",
                        ])}
                        className="custom-scrollbar"
                        placeholder="Select City"
                        onChange={(e) => HandleOnChange(e)}
                        size="large"
                        rules={validationRules.city}
                        showSearch={true}
                        onSearch={onSearch}
                        filterOption={filterOption}
                      />
                    </Col>
                    <Col span={8} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.zip}
                        name="propertyZip"
                        size="large"
                        label="Zip"
                        placeholder="Enter Property Zip"
                        onChange={(e) => handleZipChange(e)}
                      />
                    </Col>
                  </Row>
                  <p
                    style={{
                      color: "#5A7890",
                      fontSize: "16px",
                      marginBottom: "5px",
                      marginTop: "1rem",
                      fontWeight: "bold",
                    }}
                  >
                    Mailing Address
                  </p>
                  <Row gutter={16}>
                    <Col span={24} className="custom-input-box-wrap">
                      <TextInput
                        name="mailingAddress"
                        size="large"
                        label="Address"
                        placeholder="Enter Mailing Address"
                        onChange={(e) => HandleOnChange(e)}
                      />
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={8} className="custom-input-box-wrap">

                      <SelectBox
                        label="State"
                        name="mailingState"
                        options={getUniqueRecords(newStates, [
                          "name",
                          "value",
                        ])}
                        className="custom-scrollbar"
                        placeholder="Select State"
                        onChange={(e) => HandleMailingCityChange(e)}
                        size="large"
                        showSearch={true}
                        onSearch={onSearch}
                        filterOption={filterOption}
                      />
                    </Col>
                    <Col span={8} className="custom-input-box-wrap">
                      <SelectBox
                        label="City"
                        name="mailingCity"
                        options={getMailingCities(mailingCities)}
                        className="custom-scrollbar"
                        placeholder="Select City"
                        onChange={(e) => HandleOnChange(e)}
                        size="large"
                        showSearch={true}
                        onSearch={onSearch}
                        filterOption={filterOption}
                      />
                    </Col>
                    <Col span={8} className="custom-input-box-wrap">
                      <TextInput
                        rules={validationRules.notRequiredZip}
                        name="mailingZip"
                        size="large"
                        label="Zip"
                        placeholder="Enter Mailing Zip"
                        onChange={(e) => handleZipChange(e)}
                      />
                    </Col>
                  </Row>

                  <section>
                    <p
                      style={{
                        color: "#5A7890",
                        fontSize: "22px",
                        marginBottom: "5px",
                        marginTop: "3rem",
                        fontWeight: "bold",
                      }}
                    >
                      Lease Info
                    </p>
                    <Radio
                      label="Choose Type of Lease."
                      rules={validationRules.newOrRenew}
                      name="newOrRenew"
                      options={options}
                      onChange={(e) => setIsNewRegistration(e?.target?.value)}
                    />
                    <Row gutter={16}>
                      <Col span={12}>
                        <DateTimePicker
                          label="Start Date"
                          name="startDay"
                          rules={validationRules.date}
                          size="large"
                          formate="MM/DD/YYYY"
                          placeHolder="Enter Start Date"
                          onChange={handleStartDateChange}
                        />
                      </Col>
                      <Col span={12}>
                        <DateTimePicker
                          label="End Date"
                          name="endDay"
                          rules={validationRules.endDate}
                          size="large"
                          formate="MM/DD/YYYY"
                          placeHolder="Enter End Date"
                          onChange={handleEndDateChange}
                        />
                      </Col>
                    </Row>
                  </section>
                  <section style={{ marginBottom: "2rem" }}>
                    <div className="d-flex justify-content-between position-relative mt-5 mb-4">
                      <p
                        style={{
                          color: "#5A7890",
                          fontSize: "22px",
                          marginBottom: "0",
                          fontWeight: "bold",
                        }}
                      >
                        Tenant Info
                      </p>
                      <Button
                        style={{
                          borderRadius: 19,
                          border: "1px solid #5A7890",
                          color: "#5A7890",
                          backgroundColor: "#fff",
                          height: "2.5rem",
                          width: "8rem",
                        }}
                        onClick={() => {
                          showModal("Add");
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Tenant
                      </Button>
                    </div>
                    <Modal
                      title={`${page} Tenant`}
                      centered
                      footer=""
                      open={isModalVisible}
                      Ok={handleFormSubmit}
                      Cancel={handleCancel}
                      width={900}
                    >
                      {(pageName) => (
                        <Form form={tenantForm} onFinish={handleFormSubmit}>
                          <Row gutter={16}>
                            <Col span={12} className="custom-input-box-wrap">
                              <TextInput
                                rules={validationRules.firstName}
                                name="tenantFirstName"
                                size="large"
                                label="First Name"
                                placeholder="Enter First Name"
                                onChange={(e) => HandleTenantOnChange(e)}
                              />
                            </Col>
                            <Col span={12} className="custom-input-box-wrap">
                              <TextInput
                                rules={validationRules.lastName}
                                name="tenantLastName"
                                size="large"
                                label="Last Name"
                                placeholder="Enter Last Name"
                                onChange={(e) => HandleTenantOnChange(e)}
                              />
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col span={12} className="custom-input-box-wrap">
                              <TextInput
                                rules={validationRules.phone}
                                name="tenantPhone"
                                size="large"
                                label="Telephone Number"
                                placeholder="Enter Phone"
                                onChange={(e) => {
                                  handlePhoneChange(e);
                                }}
                              />
                            </Col>
                            <Col span={12} className="custom-input-box-wrap">
                              <TextInput
                                rules={validationRules.email}
                                name="tenantEmail"
                                size="large"
                                label="Email"
                                placeholder="Enter Email"
                                onChange={(e) => HandleTenantOnChange(e)}
                              />
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col span={12}>
                              <Checkbox
                                name="violation"
                                value={true}
                                style={{
                                  lineHeight: "32px",
                                }}
                                onChange={(e) => HandleTenantOnChange(e)}
                              >
                                Receive Copy of Violation
                              </Checkbox>
                            </Col>
                            <Col span={12}>
                              <Checkbox
                                name="sendCopyToTenant"
                                value={true}
                                style={{
                                  lineHeight: "32px",
                                }}
                                onChange={(e) => HandleTenantOnChange(e)}
                              >
                                Do you want to send a copy of the form to this tenant?
                              </Checkbox>
                            </Col>
                          </Row>


                          <div className="d-flex justify-content-between position-relative mt-5 mb-4">
                            <p
                              style={{
                                color: "#5A7890",
                                fontSize: "18px",
                                fontWeight: "bold",
                              }}
                            >
                              Emergency Contact
                            </p>
                            <Button
                              style={{
                                borderRadius: 19,
                                border: "1px solid #5A7890",
                                color: "#5A7890",
                                backgroundColor: "#fff",
                                height: "2.5rem",
                                width: "8rem",
                              }}
                              onClick={() => {
                                showContactModal("Add");
                              }}
                              icon={<PlusOutlined />}
                            >
                              Add Contact
                            </Button>
                          </div>
                          <Modal
                            title={`${contactPage} Contact`}
                            centered
                            footer=""
                            open={isContactModalVisible}
                            Ok={handleContactFormSubmit}
                            Cancel={handleContactCancel}
                            width={900}
                          >
                            {(pageName) => (
                              <Form
                                form={contactForm}
                                onFinish={handleContactFormSubmit}
                              >
                                <Row gutter={16}>
                                  <Col span={12} className="custom-input-box-wrap">
                                    <TextInput
                                      rules={validationRules.firstName}
                                      name="contactFirstName"
                                      size="large"
                                      label="First Name"
                                      placeholder="Enter First Name"
                                      onChange={(e) => HandleContactOnChange(e)}
                                    />
                                  </Col>
                                  <Col span={12} className="custom-input-box-wrap">
                                    <TextInput
                                      rules={validationRules.lastName}
                                      name="contactLastName"
                                      size="large"
                                      label="Last Name"
                                      placeholder="Enter Last Name"
                                      onChange={(e) => HandleContactOnChange(e)}
                                    />
                                  </Col>
                                </Row>
                                <Row gutter={16}>
                                  <Col span={12} className="custom-input-box-wrap">
                                    <TextInput
                                      rules={validationRules.email}
                                      name="contactEmail"
                                      size="large"
                                      label="Email"
                                      placeholder="Enter Email"
                                      onChange={(e) => HandleContactOnChange(e)}
                                    />
                                  </Col>
                                  <Col span={12} className="custom-input-box-wrap">
                                    <TextInput
                                      rules={validationRules.notRequiredPhone}
                                      name="contactPhone"
                                      size="large"
                                      label="Telephone Number"
                                      placeholder="Enter Phone"
                                      onChange={(e) => {
                                        handleContactPhoneChange(e);
                                      }}
                                    />
                                  </Col>
                                </Row>
                                <Row gutter={16}>
                                  <Col span={12} className="custom-input-box-wrap">
                                    <TextInput
                                      rules={validationRules.relationship}
                                      name="contactRelationship"
                                      size="large"
                                      label="Relation"
                                      placeholder="Enter Relation"
                                      onChange={(e) => HandleContactOnChange(e)}
                                    />
                                  </Col>
                                </Row>
                                <div className="mt-3" style={{ textAlign: 'right' }}>
                                  <Button
                                    htmlType="submit"
                                    class="submit-button"
                                    style={{
                                      marginLeft: 8,
                                      borderRadius: 19,
                                      color: "white",
                                      backgroundColor: "#5A7890",
                                      height: "2.5rem",
                                      width: "8rem",
                                    }}
                                  >
                                    {contactPage === "Edit" ? "Update" : "Submit"}
                                  </Button>
                                </div>

                              </Form>
                            )}
                          </Modal>
                          {contactData.length > 0 && (
                            <DynamicTable
                              columns={contactColumns}
                              data={contactData}
                            />
                          )}
                          <div style={{ textAlign: 'right' }}>
                            <Button
                              htmlType="submit"
                              class="submit-button"
                              style={{
                                marginLeft: 8,
                                borderRadius: 19,
                                color: "white",
                                backgroundColor: "#5A7890",
                                height: "2.5rem",
                                width: "8rem"
                              }}
                            >
                              {page === "Edit" ? "Update" : "Submit"}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Modal>

                    <DynamicTable columns={columns} data={tenantData} />

                    {selectedTenant && (
                      <Modal
                        title="Emergency Contacts"
                        centered
                        open={isEcModalVisible}
                        Ok={handleModalOk}
                        Cancel={handleModalCancel}
                        width={800}
                        footer={[
                          <Button key="back" onClick={handleModalCancel}>
                            Close
                          </Button>,
                        ]}
                        children={(pageName) => (
                          <DynamicTable
                            columns={[
                              { title: "Name", dataIndex: "name", key: "name" },
                              {
                                title: "Email",
                                dataIndex: "email",
                                key: "email",
                              },
                              {
                                title: "Phone",
                                dataIndex: "phone",
                                key: "phone",
                              },
                              {
                                title: "Relationship",
                                dataIndex: "relationship",
                                key: "relationship",
                              },
                            ]}
                            data={selectedTenant.EmergencyContacts.map(
                              (contact) => ({
                                key: contact.email,
                                name: `${contact.FirstName} ${contact.LastName}`,
                                email: contact.Email,
                                phone: contact.Phone,
                                relationship: contact.Relationship,
                              })
                            )}
                          />
                        )}
                      />
                    )}
                  </section>
                  <Radio
                    label="Is this Tenant registering any vehicles?"
                    name="hasVehicle"
                    options={hasVehiclesOptions}
                    value={hasVehicle}
                    onChange={(e) => setHasVehicle(e.target.value === true)}
                  />
                  {hasVehicle && (
                    <section style={{ marginBottom: "2rem" }}>
                      <div className="d-flex justify-content-between position-relative mt-2 mb-4">
                        <p
                          style={{
                            color: "#5A7890",
                            fontSize: "22px",
                            marginBottom: "0",
                            fontWeight: "bold",
                          }}
                        >
                          Vehicle Info
                        </p>
                        <Button
                          style={{
                            borderRadius: 19,
                            border: "1px solid #5A7890",
                            color: "#5A7890",
                            backgroundColor: "#fff",
                            height: "2.5rem",
                            width: "8rem",
                          }}
                          onClick={() => {
                            showVehicleModal("Add");
                          }}
                          icon={<PlusOutlined />}
                        >
                          Add Vehicle
                        </Button>
                      </div>
                      <Modal
                        title={`${vehiclePage} Vehicle`}
                        centered
                        footer=""
                        open={isVehicleModalVisible}
                        Ok={handleVehicleFormSubmit}
                        Cancel={handleVehicleCancel}
                        width={900}
                      >
                        {(pageName) => (
                          <Form
                            form={vehicleForm}
                            onFinish={handleVehicleFormSubmit}
                          >
                            <Row gutter={16}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.year}
                                  name="vehicleYear"
                                  size="large"
                                  label="Year"
                                  placeholder="Enter Year"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                />
                              </Col>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.make}
                                  name="vehicleMake"
                                  size="large"
                                  label="Make"
                                  placeholder="Enter Make"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                />
                              </Col>
                            </Row>
                            <Row gutter={16}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.model}
                                  name="vehicleModel"
                                  size="large"
                                  label="Model"
                                  placeholder="Enter Model"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                />
                              </Col>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.color}
                                  name="vehicleColor"
                                  size="large"
                                  label="Color"
                                  placeholder="Enter Color"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                />
                              </Col>
                            </Row>
                            <Row gutter={16}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.license}
                                  name="vehicleLicensePlate"
                                  size="large"
                                  label="License Plate"
                                  placeholder="Enter License Plate"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                />
                              </Col>
                              <Col span={12} className="custom-input-box-wrap">
                                <SelectBox
                                  options={getUniqueRecords(newStates, [
                                    "name",
                                    "value",
                                  ])}
                                  rules={validationRules.state}
                                  name="vehicleState"
                                  size="large"
                                  label="State"
                                  placeholder="Enter State"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                  showSearch={true}
                                  onSearch={onSearch}
                                  filterOption={filterOption}
                                />
                              </Col>
                            </Row>
                            <Row gutter={16}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.spot}
                                  name="vehicleSpot"
                                  size="large"
                                  label="Spot / Garage"
                                  placeholder="Enter Spot / Garage"
                                  onChange={(e) => HandleVehicleOnChange(e)}
                                />
                              </Col>
                            </Row>
                            <div style={{ textAlign: 'right' }}>
                              <Button
                                htmlType="submit"
                                class="submit-button"
                                style={{
                                  marginLeft: 8,
                                  borderRadius: 19,
                                  color: "white",
                                  backgroundColor: "#5A7890",
                                  height: "2.5rem",
                                  width: "8rem",
                                }}
                              >
                                {vehiclePage === "Edit" ? "Update" : "Submit"}
                              </Button>
                            </div>

                          </Form>
                        )}
                      </Modal>
                      <DynamicTable columns={vehicleColumns} data={vehicleData} />
                    </section>
                  )}
                  <Radio
                    label="Is this Tenant registering any pets?"
                    name="hasPet"
                    options={hasPetOptions}
                    value={hasPet}
                    onChange={(e) => setHasPet(e.target.value === true)}
                  />
                  {hasPet && (
                    <section>
                      <div className="d-flex justify-content-between position-relative mt-2 mb-4">
                        <p
                          style={{
                            color: "#5A7890",
                            fontSize: "22px",
                            marginBottom: "5px",
                            marginTop: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          Pets Info
                        </p>
                        <Button
                          style={{
                            borderRadius: 19,
                            border: "1px solid #5A7890",
                            color: "#5A7890",
                            backgroundColor: "#fff",
                            height: "2.5rem",
                            width: "8rem",
                          }}
                          onClick={() => {
                            showPetModal("Add");
                          }}
                          icon={<PlusOutlined />}
                        >
                          Add Pet
                        </Button>
                      </div>
                      <Modal
                        title={`${petPage} Pet`}
                        centered
                        footer=""
                        open={isPetModalVisible}
                        Ok={handlePetFormSubmit}
                        Cancel={handlePetCancel}
                        width={900}
                      >
                        {(pageName) => (
                          <Form form={petForm} onFinish={handlePetFormSubmit}>
                            <Row gutter={16}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.name}
                                  name="petName"
                                  size="large"
                                  label="Name"
                                  placeholder="Enter Name"
                                  onChange={(e) => HandlePetOnChange(e)}
                                />
                              </Col>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  name="petType"
                                  size="large"
                                  label="Type"
                                  placeholder="Enter Type"
                                  onChange={(e) => HandlePetOnChange(e)}
                                />
                              </Col>
                            </Row>
                            <Row gutter={16}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.breed}
                                  name="petBreed"
                                  size="large"
                                  label="Breed"
                                  placeholder="Enter Breed"
                                  onChange={(e) => HandlePetOnChange(e)}
                                />
                              </Col>
                              <Col span={12} className="custom-input-box-wrap">
                                <DateTimePicker
                                  label="Rabies Due Date"
                                  name="petDueDate"
                                  size="large"
                                  formate="MM/DD/YYYY"
                                  placeHolder="Enter Due Date (MM/DD/YYYY)"
                                  onChange={handleDateChange}
                                />
                              </Col>
                            </Row>
                            <Row gutter={16} justify={'end'}>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  name="petLicense"
                                  size="large"
                                  label="License#"
                                  placeholder="Enter License"
                                  onChange={(e) => HandlePetOnChange(e)}
                                />
                              </Col>
                              <Col span={12} className="custom-input-box-wrap">
                                <TextInput
                                  rules={validationRules.age}
                                  name="petAge"
                                  size="large"
                                  label="Age"
                                  placeholder="Enter Age"
                                  onChange={(e) => HandlePetOnChange(e)}
                                />
                              </Col>
                              <div className="mt-2" style={{ textAlign: 'right' }}>
                                <Button
                                  htmlType="submit"
                                  class="submit-button"
                                  style={{
                                    marginLeft: 8,
                                    borderRadius: 19,
                                    color: "white",
                                    backgroundColor: "#5A7890",
                                    height: "2.5rem",
                                    width: "8rem",
                                  }}
                                >
                                  {petPage === "Edit" ? "Update" : "Submit"}
                                </Button>
                              </div>

                            </Row>
                          </Form>
                        )}
                      </Modal>
                      <DynamicTable columns={petColumns} data={petData} />
                    </section>
                  )}
                  <p
                    style={{
                      color: "#5A7890",
                      fontSize: "22px",
                      marginBottom: "16px",
                      marginTop: "3rem",
                      fontWeight: "bold",
                    }}
                  >
                    Supporting Documents
                  </p>
                  <UploadButton
                    handlePreview={handlePreview}
                    fileList={fileList}
                    setFileList={setFileList}
                    setPreviewImage={setPreviewImage}
                    previewImages={previewImage}
                    setPreviewOpen={setPreviewOpen}
                    previewOpen={previewOpen}
                    name="files"
                    handleChange={handleChange}
                    number={10}
                  />

                  <Row gutter={16}>
                    <Col span={24} className="custom-input-box-wrap">
                      <p>Please enter email addresses separated by a semicolon, if you want to send a copy of this form to somebody else (Optional).</p>
                      <TextInput
                        name="sendCopyToEmail"
                        size="large"
                        placeholder="Enter email address to receive email"
                      />
                    </Col>
                  </Row>
                </>
              )}



              <Modal
                title="Are you sure to skip the payment at this time?"
                centered
                footer=""
                open={isConfirmVisible}
                Ok={handleConfirmCancel}
                Cancel={() => { setIsConfirmVisible(false) }}
                width={500}
              >
                {(pageName) => (
                  <>

                    <div className="mt-2" style={{ textAlign: 'right', marginTop: "1rem" }}>
                      <Button
                        htmlType="submit"
                        class="submit-button"
                        style={{
                          marginLeft: 8,
                          borderRadius: 19,
                          color: "white",
                          backgroundColor: "#5A7890",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={handleCancelConfirmation}
                      >
                        No
                      </Button>
                      <Button
                        htmlType="submit"
                        class="submit-button"
                        style={{
                          marginLeft: 8,
                          borderRadius: 19,
                          color: "white",
                          backgroundColor: "#5A7890",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={handleConfirmCancel}
                      >
                        Yes
                      </Button>
                    </div>

                  </>)}
              </Modal>
              <Modal
                title="Payment Option"
                centered
                footer=""
                open={isPaymentModalVisible}
                Cancel={handleShowConfirmation}
                width={400}
                height={!isAchPayment ? 300 : 700}
                children={PaymentOpiton}
              />

              <div className="button-row">
                <Button
                  onClick={(e) => handleClearButton(e)}
                  style={{
                    borderRadius: 19,
                    border: "1px solid #5A7890",
                    color: "#5A7890",
                    backgroundColor: "#fff",
                    height: "2.5rem",
                    width: "8rem",
                  }}
                >
                  Clear
                </Button>
                <Button
                  htmlType="submit"
                  class="submit-button"
                  style={{
                    marginLeft: 8,
                    borderRadius: 19,
                    color: "white",
                    backgroundColor: "#5A7890",
                    height: "2.5rem",
                    width: "8rem",
                  }}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </div>
      </Row>
    </>
  );
};

export default Tenant;